import { useState, useEffect } from 'react';
import { execSeatableSql } from './seatable.js';
import ArtifactSet from './artifactset.js';
import SectionHeader from './sectionheader.js';

function Artifacts(props) {
    const [data, setData] = useState(null);

    useEffect(() => {
        async function fetchData() {
            const sql = `SELECT * FROM \`Artifact\` WHERE \`Disable\` IS NOT TRUE AND NOT ISEMPTY(\`Artifact Type\`) AND \`Capability\` IN ('${props.capability}') ORDER BY \`Artifact Rank\``;
            setData(null);

            try {
                const rows = await execSeatableSql(sql);
                setData(rows && rows.results);
            } catch (err) {
                // setError(err);
            }
        }
        fetchData();
    }, [props.capability]);

    return <>
        {(data && (data.length > 0)) ? 
        <div>
            <div id="Artifacts" className='nav-margin'>
                <SectionHeader capability={props.capability} section="Artifacts"/>
            </div>
            <ArtifactSet artifacts={data} />
        </div>
        : ''}
    </>
}

export default Artifacts;